/* Structural layout only — colors come from Astryx design tokens (resolved
   inside a <Theme> scope). */

.eyebrow {
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.body {
  display: flex;
  flex-direction: column;
}
